import type { ReactNode } from 'react';

import { createContext, useState } from 'react';

interface ReorderContextValue {
  isReordered: boolean;
  setIsReordered: (value: boolean) => void;
}

export const ReorderContext = createContext<ReorderContextValue | undefined>(undefined);

export function ReorderContextProvider({ children }: { children: ReactNode }) {
  const [isReordered, setIsReordered] = useState(false);

  return (
    <ReorderContext.Provider
      value={{
        isReordered,
        setIsReordered,
      }}
    >
      {children}
    </ReorderContext.Provider>
  );
}
